import { PageType, PageTypes } from 'strapi/page/types';
import { RequestParams } from 'strapi/types';

import { CategoryListStrapiComponent } from './types';

export const categoryListParams: (
  type: PageType
) => RequestParams<
  PageTypes & { categoryList: CategoryListStrapiComponent }
> = (type) => {
  if (type === PageType.CreateLibraryPage) {
    return {
      populate: {
        categoryList: {
          populate: {
            categoriesInfo: {
              populate: {
                category: {
                  fields: ['name', 'use_cases'],
                  populate: {
                    use_cases: {
                      fields: ['name', 'create_use_case_page'],
                      populate: {
                        create_use_case_page: {
                          fields: ['cover', 'path'],
                          populate: {
                            cover: true,
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    };
  }
  if (type === PageType.ToolsLibraryPage) {
    return {
      populate: {
        toolsCategoryList: {
          populate: {
            toolsCategoriesInfo: true,
          },
        },
      },
    };
  }

  return {};
};
